export default __webpack_public_path__ + "static/media/VO_LOGO1.580eb062.svg";